import { render, staticRenderFns } from "./SettingConfig.vue?vue&type=template&id=341770c2&scoped=true"
import script from "./SettingConfig.vue?vue&type=script&lang=js"
export * from "./SettingConfig.vue?vue&type=script&lang=js"
import style0 from "./SettingConfig.vue?vue&type=style&index=0&id=341770c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341770c2",
  null
  
)

export default component.exports